/* tslintdisableno-console */
import Backbone from 'backbone'
// import $ from 'jquery'
import _ from 'underscore'
import tmpl from '../template/tmpl.html'

class MessageView extends Backbone.View {
    events () {
        return {
            'click .btn-close-msg': 'close',
        }
    }

    initialize (options) {
        this._tmpl = _.template(tmpl)
    }

    render () {
        try {
            if (!this.model.isValid()) {
                throw new Error(this.model.validationErrors)
            }

            // renderiza a msg
            const model = this.model.toJSON()
            this.$el.html(this._tmpl(model))

            // Inicia o timer para fechar a msg
            this.closeTimer()

            return this.$el
        } catch (ex) {
            console.error(ex)
        }
    }

    closeTimer () {
        _.delay(() => {
            this.$el.hide('slow', () => {
                this.$el.remove()
            })
        }, this.model.get('timer'))
    }

    close () {
        this.$el.remove()
    }

    set (data) {
        try {
            this.model.set(data)

            if (!this.model.isValid()) {
                throw new Error(this.model.validationErrors)
            }
        } catch (ex) {
            console.error(ex)
        }
    }
}

export default MessageView
